import { useState } from 'react';

import {
    ArrowLeftIcon,
    IconButton,
    SectionContainer,
    SectionTitle,
    VerticalContainer
} from '@american-autonomy/rantizo-ui';

import StripePricingTable from 'components/StripePricingTable';
import StripeSubscriptionSummary from 'components/StripeSubscriptionSummary';
import HorizontalGridContainer from 'components/containers/HorizontalGridContainer';

import useRoles from 'hooks/useRoles';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Subscriptions: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const [tableKey, setTableKey] = useState('');
    const { canManageSubscriptions } = useRoles();
    const { TITLE } = useTranslation();

    const displayPricingTable = canManageSubscriptions && tableKey;

    const handleBack = () => {
        setTableKey('');
    };

    return (
        <SectionContainer testId={testId}>
            <SectionTitle text={TITLE} />

            {displayPricingTable && (
                <HorizontalGridContainer className={styles.horizontalGridContainer}>
                    <IconButton className={styles.iconButton} onClick={handleBack}>
                        <ArrowLeftIcon className={styles.arrowLeftIcon} />
                    </IconButton>

                    <StripePricingTable pricingTableId={tableKey} />
                </HorizontalGridContainer>
            )}

            {!tableKey && (
                <VerticalContainer className={styles.verticalContainer}>
                    <StripeSubscriptionSummary setTableKey={setTableKey} />
                </VerticalContainer>
            )}
        </SectionContainer>
    );
};

export default Subscriptions;
